// src/firebase.js
// ─────────────────────────────────────────────────────────────────
// STEP: Replace the values below with your own Firebase project config.
// Get them from: https://console.firebase.google.com
//   → Your project → Project Settings → "Your apps" → Web app → Config
// ─────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAROU-k2K2E3hhlWpmPdqDKz1JOqU5xYzI",
  authDomain: "chessingit.firebaseapp.com",
  databaseURL: "https://chessingit-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chessingit",
  storageBucket: "chessingit.firebasestorage.app",
  messagingSenderId: "447256431143",
  appId: "1:447256431143:web:9fbf5c91ef67598d6a5c02"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export default app;
